import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showModal,
  hideModal,
  resetOriginalDeedModalData,
} from "../../modal/OriginalDeedModalSlice";
import {
  hideCommercialModal,
  showCommercialModal,
} from "../../modal/modalSlices/CommercialModalSlice";
import {
  hideResidentialModal,
  showResidentialModal,
} from "../../modal/modalSlices/ResidentialModalSlice";

import {
  fetchDistrictData,
  fetchSROData,
  fetchDeedData,
  fetchSubdeedData,
  fetchBookNo,
  fetchLandRateCalculation,
  fetchMutationDetail,
  fetchFloorNoData,
  fetchUnitData,
  fetchRiderData,
  fetchVillageIndex,
  fetchMutationOfficeData,
  fetchMutationOfficeDetail,
  setShowRatelist,
  fetchRateListDetails,
  insertPropertyData,
  insertAreaMajData,
  fetchFloorMassResi,
  fetchFloorMassComm,
  updatePropertyData,
  updateAreaMajData,
} from "../propertySlice";
import RateListModal from "../../modal/RateListModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "./LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";
import {
  completeStep,
  nextStep,
  goToStep,
  prevStep,
  resetSteps,
} from "../../Stepper/stepperSlice";
import OriginalDeedModal from "../../modal/OriginalDeedModal";
import ResidentialModal from "../../modal/ResidentialModal";
import CommercialModal from "../../modal/CommercialModal";
import { selectLoggedInUser } from "../../auth/authSlice";
import {
  clearOnDeedChange,
  clearOnRateListChange,
  updatePropertyForm,
} from "../inputFieldSlices/propertyInputSlice";
import {
  fetchPDEInfoAsync,
  selectPDEInfo,
  selectUser,
} from "../../user/userSlice";
import { pinwheel } from "ldrs";
import { selectPropertyMod, setPropertyMod } from "../../Modify/ModifySlice";

import TypewriterAnimation from "../../Loader/TypewriterAnimation";
import { toast } from "react-toastify";
import { initPdeStatus } from "../../ReviewApproval/ReviewApprovalSlice";
import { resetPropertyEvaluationForm } from "../inputFieldSlices/propertyEvaluationInputSlice";
import { persistor } from "../../../app/store";
import API_BASE_URL from "../../BaseURL/baseURL";

const Property = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectLoggedInUser);
  const userInfo = useSelector(selectUser);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  const pdeMod = pdeData?.pdE_ID;
  const PaymentStatus = pdeInfo?.paymentStatus[0];
  const rfeeStatus = PaymentStatus?.rfeeStatus;
  const StampStatus = PaymentStatus?.stampStatus;

  // Start changes for to persist input fields
  const formInputData = useSelector((state) => state.propertyInput.formData);

  //End changes for to persist input fields

  const showRatelist = useSelector((state) => state.property.showRatelist);
  const rateListDetails = useSelector(
    (state) => state.property.rateListDetails
  );
  const [selectedRateDetails, setSelectedRateDetails] = useState(null);
  const error = useSelector((state) => state.property.error);

  const showModalState = useSelector((state) => state.originalDeed.show);
  const showCommercialModalState = useSelector(
    (state) => state.CommercialModal.Commercialshow
  );
  const showResidentialModalState = useSelector(
    (state) => state.ResidentialModal.Residentialshow
  );

  const norm = (s) => (s || "").trim().toLowerCase();

  const {
    districtOptions,
    sroOptions,
    deedOptions,
    subDeedOptions,
    bookNoOptions,
    landRateCalculationOptions,
    villageIndexOptions,
    mutationOptions,
    mutationOfficeOptions,
    floorMasOptions,
    unitOptions,
    riderOptions,

    insertedPropertyData,
  } = useSelector((state) => state.property);

  const [rateyear, setrateyear] = useState("");

  const [coOwnerFlag, setCoOwnerFlag] = useState("False");
  const currentStep = useSelector((state) => state.stepper.currentStep);
  const propertyMod = useSelector(selectPropertyMod);

  const Navigate = useNavigate();

  const formData = useSelector((state) => state.originalDeed.formData);
  const refDafa60 = formData.refDafa60;
  const residentialData = useSelector(
    (state) => state.ResidentialModal.formResiData
  );
  const commercialData = useSelector((state) => state.CommercialModal.formData);

  const numbers = [1, 2, 3, 4, 5]; // Replace this with actual data if needed
  const [isLoading, setIsLoading] = useState(false);
  // NEW: GIS lookup state
  const [gisLookup, setGisLookup] = useState(null);
  const [isGisLoading, setIsGisLoading] = useState(false);
  const needsGis = ["01", "03", "25"].includes(formInputData?.deedcode);

  useEffect(() => {
    dispatch(fetchDistrictData());
    dispatch(fetchDeedData());
  }, []);

  useEffect(() => {
    if (formInputData.dcode || formInputData.secDcode) {
      dispatch(fetchSROData(formInputData.dcode));
    }
  }, [formInputData.dcode]);

  useEffect(() => {
    if (formInputData.secDcode) {
      dispatch(fetchSROData(formInputData.secDcode));
    }
  }, [formInputData.secDcode]);

  useEffect(() => {
    if (formInputData.deedcode) {
      dispatch(fetchSubdeedData(formInputData.deedcode));
      dispatch(fetchBookNo(formInputData.deedcode));
      dispatch(fetchMutationDetail());

      dispatch(fetchFloorNoData());
      dispatch(fetchUnitData());
      dispatch(fetchRiderData());
    }
  }, [formInputData?.deedcode]);

  useEffect(() => {
    if (formInputData?.rateyear) setrateyear(formInputData.rateyear);
  }, [formInputData?.rateyear]);

  // useEffect(() => {
  //   setIsLoading(true);
  //   dispatch(
  //     fetchLandRateCalculation({
  //       dcode: formInputData?.dcode,
  //       srocode: formInputData?.srocode,
  //       ratelist_year: formInputData?.rateyear,
  //     })
  //   ).finally(() => setIsLoading(false));
  // }, [formInputData?.dcode, formInputData?.srocode]);

  useEffect(() => {
    if (
      !formInputData?.dcode ||
      !formInputData?.srocode ||
      !formInputData?.rateyear
    )
      return;
    setIsLoading(true);
    dispatch(
      fetchLandRateCalculation({
        dcode: formInputData?.dcode,
        srocode: formInputData?.srocode,
        ratelist_year: rateyear,
      })
    ).finally(() => setIsLoading(false));
  }, [formInputData?.dcode, formInputData?.srocode, rateyear]);

  useEffect(() => {
    if (formInputData.mutationDepartment) {
      dispatch(
        fetchMutationOfficeDetail({
          mutationDepartment: formInputData.mutationDepartment,
          dcode: formInputData.dcode,
          srocode: formInputData.srocode,
        })
      );
    }
  }, [formInputData.mutationDepartment]);

  useEffect(() => {
    if (
      formInputData.deedcode === "26" ||
      formInputData.deedcode === "06" ||
      formInputData.deedcode === "32" ||
      formInputData.deedcode === "33" ||
      formInputData.deedcode === "37" ||
      (formInputData.deedcode === "20" &&
        (formInputData.subDeedCode === "05" ||
          formInputData.subDeedCode === "06"))
    ) {
      dispatch(showModal()); // Dispatch action to show the modal
    } else {
      dispatch(hideModal()); // Dispatch action to close the modal
    }
  }, [formInputData.deedcode, formInputData.subDeedCode]);

  // useEffect(() => {
  //   if (propertyMod && pdeData && landRateCalculationOptions?.length > 0) {
  //     debugger;
  //     // Trim both values for a proper match
  //     const matchedOption = landRateCalculationOptions?.find(
  //       (option) =>
  //         option.segmentdesc?.trim() === pdeData?.locationCircleRate?.trim()
  //     );

  //     const mauzaOption = landRateCalculationOptions.find(
  //       (option) => option.segmentdesc?.trim() === pdeData?.location?.trim()
  //     );

  //     // Update form state with the correct `segmentcode`
  //     dispatch(
  //       updatePropertyForm({
  //         ...formInputData,
  //         location: mauzaOption ? mauzaOption : "",
  //         location_circle_rate: matchedOption ? matchedOption : "",
  //         locationCircleRate: matchedOption ? matchedOption.segmentcode : "",
  //         villageMauza: mauzaOption ? mauzaOption.segmentcode : "",
  //         disableFlag: pdeData.disableFlag === "Y" ? "Y" : "N",
  //         femaleBuyer: pdeData.femaleBuyer === "Y" ? "Y" : "N",
  //         armyFlag: pdeData.armyFlag === "Y" ? "Y" : "N",
  //         coOwnerFlag: pdeData.coOwnerFlag === "Y" ? "Y" : "N",
  //         // villageCode: pdeData.villageCode || "",
  //       })
  //     );
  //   }
  // }, [propertyMod, pdeData, landRateCalculationOptions]);

  useEffect(() => {
    if (
      propertyMod &&
      pdeData &&
      Array.isArray(landRateCalculationOptions) &&
      landRateCalculationOptions.length > 0
    ) {
      // find by description (same as your current logic)
      const matchedOption = landRateCalculationOptions.find(
        (o) =>
          (o.segmentdesc || "").trim() ===
          (pdeData?.locationCircleRate || "").trim()
      );
      const mauzaOption = landRateCalculationOptions.find(
        (o) => (o.segmentdesc || "").trim() === (pdeData?.location || "").trim()
      );

      // build a patch ONLY with fields that actually matched
      const patch = {
        // flags (idempotent)
        disableFlag: pdeData.disableFlag === "Y" ? "Y" : "N",
        femaleBuyer: pdeData.femaleBuyer === "Y" ? "Y" : "N",
        armyFlag: pdeData.armyFlag === "Y" ? "Y" : "N",
        coOwnerFlag: pdeData.coOwnerFlag === "Y" ? "Y" : "N",
      };

      // === Land Rate Calculation (bind same way as mauza) ===
      if (matchedOption) {
        patch.location_circle_rate = matchedOption; // object (like your mauza's `location`)
        patch.locationCircleRate = matchedOption.segmentcode; // value for the <select>
      }

      // === Village / Mauza (your working path) ===
      if (mauzaOption) {
        patch.location = mauzaOption; // object
        patch.villageMauza = mauzaOption.segmentcode; // value
      }

      // only dispatch if we actually resolved something — never write empty strings
      if (matchedOption || mauzaOption) {
        dispatch(updatePropertyForm(patch));
      }
    }
  }, [propertyMod, pdeData, landRateCalculationOptions]);

  // Auto-load GIS when editing (propertyMod) and deed needs GIS
  useEffect(() => {
    const autoLoad = async () => {
      if (!(propertyMod && pdeMod && needsGis)) return;

      try {
        const metaRes = await fetch(
          `${API_BASE_URL}/PropertyRegistration/Virtual_Get_GisId?pdeId=${pdeMod}`,
          { method: "GET" }
        );

        if (metaRes.ok) {
          const meta = await metaRes.json(); // this is an array
          const gisNo = meta?.[0]?.giS_ID || "";

          if (gisNo) {
            await fetchAndSetGisByNo(gisNo);
          }
        }
      } catch (err) {
        console.error("Auto-load GIS failed", err);
      }
    };

    autoLoad();
  }, [propertyMod, pdeMod, needsGis]);

  // Reusable: fetch GIS by GIS No and write to form + local state
  const fetchAndSetGisByNo = async (gisNo) => {
    if (!gisNo) return;
    setIsGisLoading(true);
    try {
      const url = `${API_BASE_URL}/PropertyRegistration/gis/getlocation/${encodeURIComponent(
        gisNo
      )}`;
      const res = await fetch(url, { method: "GET" });
      if (!res.ok) throw new Error(`GIS API error: ${res.status}`);

      const data = await res.json(); // { GIS_ID, Latitude, Longitude, ... }

      const lat = data?.Latitude != null ? parseFloat(data.Latitude) : 0;
      const lon = data?.Longitude != null ? parseFloat(data.Longitude) : 0;

      dispatch(
        updatePropertyForm({
          // ...formInputData,
          latitude: Number.isFinite(lat) ? String(lat) : "0",
          longitude: Number.isFinite(lon) ? String(lon) : "0",
          gisNo,
        })
      );

      setGisLookup(data);
    } finally {
      setIsGisLoading(false);
    }
  };

  const handleGisSearch = async () => {
    const gisNo = (formInputData.gisNo || "").trim();
    if (!gisNo) {
      toast.warning("Please enter GIS No first");
      return;
    }
    try {
      await fetchAndSetGisByNo(gisNo);
      toast.success("GIS details fetched");
    } catch {
      toast.error("Failed to fetch GIS details");
    }
  };

  const handleRatetListRadio = (e) => {
    const val = e.target.value;
    setrateyear(val);
    dispatch(updatePropertyForm({ rateyear: val })); // no spread - just set the key
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? (checked ? "Y" : "N") : value;
    console.log("🔥 handleInputChange:", name, value);

    let updatedFormData = {
      ...formInputData,
      [name]: inputValue,
    };

    if (name === "dcode" || name === "srocode") {
      updatedFormData = {
        ...updatedFormData,
        locationCircleRate: "",
        location_circle_rate: null,
        villageMauza: "",
        location: null,
        circle_rate: "",

        mutationDepartment: "",
        mutationOfficeCode: "",

        secDcode: "",
        secSrocode: "",
      };
    }

    if (name === "deedcode") {
      console.log("👉 deedcode branch, clearing…");
      // 1) clear every field except dcode & srocode in propertyInput
      dispatch(clearOnDeedChange());
      // persistor.flush();
      // 2) clear the evaluation inputs entirely
      dispatch(resetPropertyEvaluationForm());
      dispatch(resetOriginalDeedModalData());
      window.sessionStorage.removeItem("propertyEvalFormData");
      // 3) save the new deedcode
      dispatch(
        updatePropertyForm({
          dcode: formInputData.dcode,
          srocode: formInputData.srocode,
          deedcode: inputValue,
        })
      );
      return;
    }

    dispatch(updatePropertyForm(updatedFormData));
  };

  // const handleSelectChange = async (e) => {
  //   // setsegmentcode(e.target.value);
  //   const selectedValue = e.target.value;
  //   debugger;
  //   const selectOption = landRateCalculationOptions.find(
  //     (option) => option.segmentcode === selectedValue
  //   );

  //   // 1) clear every field except dcode & srocode in propertyInput
  //   dispatch(clearOnRateListChange());
  //   // persistor.flush();
  //   // 2) clear the evaluation inputs entirely
  //   dispatch(resetPropertyEvaluationForm());
  //   dispatch(resetOriginalDeedModalData());
  //   // 3) save the new deedcode
  //   dispatch(
  //     updatePropertyForm({
  //       // re-preserve your four fields
  //       dcode: formInputData.dcode,
  //       srocode: formInputData.srocode,
  //       deedcode: formInputData.deedcode,
  //       subDeedCode: formInputData.subDeedCode,
  //     })
  //   );

  //   //ADDED because i want to clear the fields on change of locationCircleRate

  //   let updatedFormData = {
  //     ...formInputData,
  //     locationCircleRate: selectedValue,
  //     location_circle_rate: selectOption,

  //     // Clear dependent fields
  //     villageMauza: "",
  //     location: null,
  //     circle_rate: "",
  //     mutationDepartment: "",
  //     mutationOfficeCode: "",
  //   };

  //   dispatch(updatePropertyForm(updatedFormData));

  //   // Dispatch the thunk to fetch rate list details
  //   dispatch(
  //     fetchRateListDetails({
  //       dcode: formInputData.dcode,
  //       scocode: formInputData.srocode,
  //       allcode: selectedValue,
  //       rateyear: "From 16 feb 2023",
  //     })
  //   );
  //   // Show the modal after fetching the rate list details
  //   dispatch(setShowRatelist(true));
  // };

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selectOption = landRateCalculationOptions.find(
      (o) => o.segmentcode === selectedValue
    );

    // 1) clear everything except those four keys
    dispatch(clearOnRateListChange());
    dispatch(resetPropertyEvaluationForm());
    dispatch(resetOriginalDeedModalData());
    window.sessionStorage.removeItem("propertyEvalFormData");

    // 2) now *directly* write back
    dispatch(
      updatePropertyForm({
        // preserved
        dcode: formInputData.dcode,
        srocode: formInputData.srocode,
        deedcode: formInputData.deedcode,
        subDeedCode: formInputData.subDeedCode,

        // new rate-list fields
        locationCircleRate: selectedValue,
        location_circle_rate: selectOption,
        area: "",
        rateyear: formInputData.rateyear || rateyear,

        // everything else is gone
      })
    );

    // 3) fetch + show
    dispatch(
      fetchRateListDetails({
        dcode: formInputData.dcode,
        scocode: formInputData.srocode,
        allcode: selectedValue,
        rateyear: formInputData.rateyear,
      })
    );
    dispatch(setShowRatelist(true));
  };

  const handleMauzaChange = async (e) => {
    // setsegmentcode(e.target.value);
    const selectedValue = e.target.value;
    const selectOption = landRateCalculationOptions.find(
      (option) => option.segmentcode === selectedValue
    );
    dispatch(
      updatePropertyForm({
        ...formInputData,
        villageMauza: selectedValue,
        location: selectOption,
      })
    );
  };

  const handleCloseModal = () => {
    dispatch(setShowRatelist(false));
  };
  const handleSelectRate = (selectedItem) => {
    dispatch(
      updatePropertyForm({
        ...formInputData,
        circle_rate: selectedItem.rate,
      })
    );
    setSelectedRateDetails(selectedItem);
    handleCloseModal();
  };

  const rateList =
    rateListDetails &&
    rateListDetails.getRateList &&
    rateListDetails.getRateList.length > 0
      ? rateListDetails
      : null;
  const appId =
    selectedRateDetails && selectedRateDetails?.appid
      ? selectedRateDetails?.appid.split(",")
      : [];

  //Trial handle save to incorporate validation

  const handleSave = async () => {
    setIsLoading(true);
    if (bookNoOptions === "1") {
      // Define required fields and labels for error messages
      let requiredFields = [
        { field: "dcode", label: "District" },
        { field: "srocode", label: "SRO" },
        { field: "deedcode", label: "Select Article/Deed Type" },
        { field: "subDeedCode", label: "Select Sub Article/Sub-Deed Type" },
        { field: "locationCircleRate", label: "locationCircleRate" },
        // { field: "villageMauza", label: "villageMauza" },
        { field: "circle_rate", label: "Circle Rate" },
        { field: "mutationDepartment", label: "Select Mutation Details" },
        { field: "mutationOfficeCode", label: "Select Office Details" },
        { field: "area", label: "area" },
        { field: "unit", label: "unit" },
      ];

      // Conditionally add selectedVillageIndex with a different label
      if (formInputData.deedcode !== "10") {
        let selectedVillageIndexLabel =
          formInputData.deedcode === "10"
            ? "Secondary Property Location"
            : "Village/ Mauza for Index";

        requiredFields.push({
          field: "villageMauza",
          label: selectedVillageIndexLabel,
        });
      }

      // Conditionally remove "mutationDepartment" and "mutationOfficeCode" if deedcode === "10"
      if (formInputData.deedcode === "10") {
        requiredFields = requiredFields.filter(
          (field) =>
            field.field !== "mutationDepartment" &&
            field.field !== "mutationOfficeCode"
        );
      }

      // if (needsGis) {
      //   requiredFields.push(
      //     { field: "gisNo", label: "GIS No" },
      //     { field: "latitude", label: "Property Latitude" },
      //     { field: "longitude", label: "Property Longitude" }
      //   );
      // }

      // Check for missing fields
      const missingFields = requiredFields.filter(
        ({ field }) => !formInputData[field]
      );
      if (missingFields.length > 0) {
        // Show error message for each missing required field
        const fieldNames = missingFields.map(({ label }) => label).join(", ");
        toast.warning(`Please fill in the required fields: ${fieldNames}`);
        setIsLoading(false);
        return;
      }
    } else {
      let requiredFields = [
        { field: "dcode", label: "District" },
        { field: "srocode", label: "SRO" },
        { field: "deedcode", label: "Select Article/Deed Type" },
        { field: "subDeedCode", label: "Select Sub Article/Sub-Deed Type" },
      ];
      if (
        formData?.refDafa60 === "" &&
        (formInputData.deedcode === "26" ||
          formInputData.deedcode === "06" ||
          formInputData.deedcode === "32" ||
          formInputData.deedcode === "33" ||
          formInputData.deedcode === "37" ||
          (formInputData.deedcode === "20" &&
            (formInputData.subDeedCode === "05" ||
              formInputData.subDeedCode === "06")))
      ) {
        requiredFields.push(
          { field: "formdata.ref_Dafa60", label: "Dafa 60" },
          { field: "ref_srocode", label: "SRO Code" },
          { field: "ref_date", label: "Registration Date" },
          { field: "ref_regno", label: "Registration Number" }
        );
      }

      // Check for missing fields
      const missingFields = requiredFields.filter(
        ({ field }) => !formInputData[field]
      );
      if (missingFields.length > 0) {
        // Show error message for each missing required field
        const fieldNames = missingFields.map(({ label }) => label).join(", ");
        toast.warning(`Please fill in the required fields: ${fieldNames}`);
        setIsLoading(false);
        return;
      }
    }

    // if (needsGis && !gisLookup) {
    //   toast.warning(
    //     "Please click the GIS search icon to fetch details before saving."
    //   );
    //   setIsLoading(false);
    //   return;
    // }

    const coOwnerFlagString = coOwnerFlag ? "True" : "False";

    const propertyData = {
      email: user.email,
      dcode: formInputData?.dcode,
      srocode: formInputData?.srocode,
      Bookno: bookNoOptions,
      deedcode: formInputData?.deedcode,
      subDeedCode: formInputData?.subDeedCode,
      location: formInputData.location?.segmentdesc ?? "",
      location_circle_rate:
        formInputData.location_circle_rate?.segmentdesc ?? "",
      sec_dcode: formInputData?.secDcode,
      sec_srocode: formInputData?.secSrocode,
      villageCode: formInputData.location?.segmentcode ?? "",
      mutation_department: formInputData?.mutationDepartment,
      mutation_office_code: formInputData?.mutationOfficeCode,
      femaleBuyer: formInputData?.femaleBuyer ? "Y" : "N",
      disable_flag: formInputData?.disableFlag ? "Y" : "N",
      army_flag: formInputData?.armyFlag ? "Y" : "N",
      co_ower_flag: formInputData.coOwnerFlag ? "Y" : "N",
      cO_OWNER_NO: formInputData?.coOwnerNo
        ? parseInt(formInputData?.coOwnerNo)
        : 0,
      khasra: formInputData?.khasra,
      khewat: formInputData?.khewat,
      khatoni: formInputData?.khatoni,
      house_No: formInputData?.houseNo,
      floorno: formInputData?.floorno,
      area: formInputData?.area,
      unit: formInputData?.unit,
      latitude: formInputData?.latitude
        ? parseFloat(formInputData.latitude)
        : 0,
      longitude: formInputData?.longitude
        ? parseFloat(formInputData?.longitude)
        : 0,
      rider_code: formInputData?.riderCode,
      east: formInputData?.east,
      west: formInputData?.west,
      north: formInputData?.north,
      south: formInputData?.south,
      ref_Dafa60: formData?.refDafa60,
      ref_srocode: formData?.refSrocode,
      ref_date: formData?.refRegdate,
      ref_regno: formData?.refRegno ? parseInt(formData.refRegno) : 0,
      password: userInfo?.password,
      mobileno: userInfo?.mobileNo,
      dt_Const_resi_Details: {
        flwr_Type: residentialData ? residentialData.floorType : "",
        pro_area: residentialData ? residentialData.propertyArea : "",
        const_type: residentialData ? residentialData.constructionType : "",
        const_year: residentialData ? residentialData.constructionYear : "",
        area: 0,
        flwr_Code: "01",
        pro_Code: "01",
        const_Code: "01",
        valution: 0,
      },
      dt_Const_comm_Details: {
        flwr_Type: "",
        area: 0,
        flwr_Code: "",
        valution: 0,
      },
    };
    try {
      const response = await dispatch(insertPropertyData(propertyData));
      if (insertPropertyData.fulfilled.match(response)) {
        toast.success("Property data inserted successfully!");
        const pde = response.payload[0].pdE_ID;
        const Bookno = response.meta.arg.Bookno;
        const areaMajData = {
          pdE_ID: pde,
          parganacode: selectedRateDetails?.parganacode || "", // Default to empty string if null
          segmentcode: formInputData?.location_circle_rate?.segmentcode || "",
          AreaMajcode: appId?.[1] || "",
          Areacode: appId?.[2] || "",
          pargananame: selectedRateDetails?.pargananame || "",
          AreaMajcodedesc: appId?.[3] || "",
          Areacodedesc: appId?.[4] || "",
          segmentdesc: formInputData?.location_circle_rate?.segmentdesc || "",
          rateListYear: rateyear || "",
          rate: selectedRateDetails?.rate
            ? parseInt(selectedRateDetails.rate)
            : 0, // Ensure rate is always a number
        };

        const insertMajResponse = await dispatch(
          insertAreaMajData(areaMajData)
        );

        if (!insertMajResponse.error) {
          toast.success("Maj data inserted successfully");
          // added to track pde review status
          await dispatch(
            initPdeStatus({
              pdeId: pde,
              dcode: formInputData.dcode,
              srocode: formInputData.srocode,
              updatedBy: user.email,
            })
          ).unwrap();

          // Save GIS response “as is” after main + Maj save succeed
          if (needsGis || gisLookup) {
            // Guard: for required deeds, user must fetch GIS first
            // if (needsGis && !gisLookup) {
            //   toast.warning(
            //     "Please click the GIS search icon to fetch details before saving."
            //   );
            //   setIsLoading(false);
            //   return; // ⛔ stop here
            // }

            try {
              const toStr = (v) => (v == null ? "" : String(v));
              const gl = gisLookup || {};

              const payload = {
                pdE_ID: toStr(pde),
                giS_ID: toStr(
                  gl.GIS_ID ?? gl.giS_ID ?? gl.gis_id ?? formInputData?.gisNo
                ),
                latitude: toStr(
                  gl.Latitude ?? gl.latitude ?? formInputData?.latitude
                ),
                longitude: toStr(
                  gl.Longitude ?? gl.longitude ?? formInputData?.longitude
                ),
                property_Type: toStr(
                  gl.Property_Type ?? gl.property_Type ?? ""
                ),
                circle_Rate: toStr(
                  gl.Circle_Rate ?? gl.circle_Rate ?? gl.circleRate ?? ""
                ),
                attachment: toStr(gl.Attachment ?? gl.attachment ?? ""),
              };

              const res = await fetch(
                `${API_BASE_URL}/PropertyRegistration/GIS_Insert_Update`,
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(payload),
                }
              );

              // Treat any non-2xx as failure and block navigation
              const ctype = res.headers.get("content-type") || "";
              const body = ctype.includes("application/json")
                ? await res.json().catch(() => null)
                : await res.text().catch(() => "");

              if (!res.ok) {
                const msg =
                  (body &&
                    typeof body === "object" &&
                    (body.message || body.error)) ||
                  (typeof body === "string" ? body : "") ||
                  `HTTP ${res.status}`;
                console.warn("GIS save failed:", res.status, body);
                toast.error(`GIS details could not be saved. ${msg}`);
                setIsLoading(false);
                return; // ⛔ stop here, do NOT navigate
              }
              // (Optional) toast.success("GIS details saved");
            } catch (e) {
              console.error("GIS save failed:", e);
              toast.error(
                "GIS details could not be saved. Check your connection and try again."
              );
              setIsLoading(false);
              return; // ⛔ stop here
            }
          }
          dispatch(nextStep());
          dispatch(completeStep({ step: 1, completed: true }));
          dispatch(fetchPDEInfoAsync(pde));
          dispatch(setPropertyMod(true));

          Navigate("/PropertyEvaluationPage");
        } else {
          console.error(
            "Error inserting Maj data:",
            insertMajResponse.error.message
          );
          toast.error(
            "Error inserting Maj data: " + insertMajResponse.error.message
          );
        }
      } else {
        // Handle the error case, e.g., display an error message
        console.error("Error occurred:", response.error.message);
        toast.error("Unexpected error: " + error.message);
      }
    } catch (error) {
      console.error("Failed to insert property data:", error);
      // Handle error, e.g., show an error message
    } finally {
      setIsLoading(false);
    }
  };

  const openResidentialModal = () => {
    dispatch(showResidentialModal());
  };

  const closeResidentialModal = () => {
    dispatch(hideResidentialModal());
  };

  const openCommercialModal = () => {
    dispatch(showCommercialModal(true));
  };

  const closeCommercialModal = () => {
    dispatch(hideCommercialModal(true));
  };

  const handleUpdate = async () => {
    setIsLoading(true);

    const propertyData = {
      pde_id: pdeMod,
      email: user?.email,
      dcode: formInputData?.dcode,
      srocode: formInputData?.srocode,
      Bookno: bookNoOptions,
      deedcode: formInputData?.deedcode,
      subDeedCode: formInputData?.subDeedCode,
      location: formInputData?.location?.segmentdesc || "",
      location_circle_rate: formInputData?.location_circle_rate?.segmentdesc,
      sec_dcode: formInputData?.secDcode,
      sec_srocode: formInputData?.secSrocode,
      villageCode: formInputData?.location?.segmentcode || "",
      mutation_department: formInputData?.mutationDepartment,
      mutation_office_code: formInputData?.mutationOfficeCode,
      // femaleBuyer: formInputData?.femaleBuyer,
      // disable_flag: formInputData?.disableFlag,
      // army_flag: formInputData?.armyFlag,
      // co_ower_flag: formInputData?.coOwnerFlag,
      femaleBuyer: formInputData.femaleBuyer === true ? "Y" : "N",
      disable_flag: formInputData.disableFlag === true ? "Y" : "N",
      army_flag: formInputData.armyFlag === true ? "Y" : "N",
      co_ower_flag: formInputData.coOwnerFlag === true ? "Y" : "N",
      cO_OWNER_NO: formInputData?.coOwnerNo
        ? parseInt(formInputData?.coOwnerNo)
        : 0,
      khasra: formInputData?.khasra,
      khewat: formInputData?.khewat,
      khatoni: formInputData?.khatoni,
      house_No: formInputData?.houseNo,
      floorno: formInputData?.floorno,
      area: formInputData?.area,
      unit: formInputData?.unit,
      latitude: formInputData?.latitude
        ? parseFloat(formInputData?.latitude)
        : 0,
      longitude: formInputData?.longitude
        ? parseFloat(formInputData?.longitude)
        : 0,
      rider_code: formInputData?.riderCode,
      east: formInputData?.east,
      west: formInputData?.west,
      north: formInputData?.north,
      south: formInputData?.south,
      ref_Dafa60: formData?.refDafa60,
      ref_srocode: formData?.refSrocode,
      ref_date: formData?.refRegdate,
      ref_regno: formData?.refRegno ? parseInt(formData.refRegno) : 0,
      password: userInfo?.password,
      mobileno: userInfo?.mobileNo,
      dt_Const_resi_Details: {
        flwr_Type: residentialData?.floorType || "",
        pro_area: residentialData?.propertyArea || "",
        const_type: residentialData?.constructionType || "",
        const_year: residentialData?.constructionYear || "",
        area: 0,
        flwr_Code: "01",
        pro_Code: "01",
        const_Code: "01",
        valution: 0,
      },
      dt_Const_comm_Details: {
        flwr_Type: "",
        area: 0,
        flwr_Code: "",
        valution: 0,
      },
    };

    try {
      const response = await dispatch(updatePropertyData(propertyData));
      if (response.meta.requestStatus === "fulfilled") {
        toast.success("Property data updated successfully!");
        const pde = response.payload[0]?.pdE_ID;
        const Bookno = String(response.meta.arg?.Bookno); // Ensure Bookno is a string

        // Save GIS response “as is” on UPDATE too (same as Save flow)
        if (needsGis || gisLookup) {
          // if (needsGis && !gisLookup) {
          //   toast.warning("Please fetch GIS details before saving.");
          //   setIsLoading(false);
          //   return;
          // }
          try {
            const toStr = (v) => (v == null ? "" : String(v));
            const gl = gisLookup || {};
            const payload = {
              pdE_ID: toStr(pde),
              giS_ID: toStr(
                gl.GIS_ID ?? gl.giS_ID ?? gl.gis_id ?? formInputData?.gisNo
              ),
              latitude: toStr(
                gl.Latitude ?? gl.latitude ?? formInputData?.latitude
              ),
              longitude: toStr(
                gl.Longitude ?? gl.longitude ?? formInputData?.longitude
              ),
              property_Type: toStr(gl.Property_Type ?? gl.property_Type ?? ""),
              circle_Rate: toStr(
                gl.Circle_Rate ?? gl.circle_Rate ?? gl.circleRate ?? ""
              ),
              attachment: toStr(gl.Attachment ?? gl.attachment ?? ""),
            };

            const res = await fetch(
              `${API_BASE_URL}/PropertyRegistration/GIS_Insert_Update`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              }
            );

            const ctype = res.headers.get("content-type") || "";
            const body = ctype.includes("application/json")
              ? await res.json().catch(() => null)
              : await res.text().catch(() => "");

            if (!res.ok) {
              const msg =
                (body &&
                  typeof body === "object" &&
                  (body.message || body.error)) ||
                (typeof body === "string" ? body : "") ||
                `HTTP ${res.status}`;
              toast.error(`GIS details could not be saved. ${msg}`);
              setIsLoading(false);
              return;
            }
          } catch (e) {
            toast.error(
              "GIS details could not be saved. Check your connection and try again."
            );
            setIsLoading(false);
            return;
          }
        }

        if (propertyMod && !selectedRateDetails?.rate) {
          dispatch(nextStep());
          dispatch(completeStep({ step: currentStep, completed: true }));
          dispatch(fetchPDEInfoAsync(pde));
          Navigate("/PropertyEvaluationPage");
        } else {
          const areaMajData = {
            pdE_ID: pdeMod,
            parganacode: selectedRateDetails?.parganacode || "",
            segmentcode: formInputData?.location_circle_rate?.segmentcode,
            AreaMajcode: appId[1] || "",
            Areacode: appId[2] || "",
            pargananame: selectedRateDetails?.pargananame || "",
            AreaMajcodedesc: appId[3] || "",
            Areacodedesc: appId[4] || "",
            segmentdesc: formInputData?.location_circle_rate?.segmentdesc || "",
            rateListYear: rateyear,
            rate: selectedRateDetails?.rate
              ? parseInt(selectedRateDetails?.rate)
              : 0,
          };
          try {
            const insertMajResponse = await dispatch(
              updateAreaMajData(areaMajData)
            );
            if (!insertMajResponse?.error) {
              toast.success("Maj data updated successfully");
              dispatch(nextStep());
              dispatch(completeStep({ step: 1, completed: true }));
              dispatch(fetchPDEInfoAsync(pde));
              Navigate("/PropertyEvaluationPage");
            } else {
              console.error(
                "Error inserting Maj data:",
                insertMajResponse.error.message
              );
              toast.error(
                "Error inserting Maj data: " + insertMajResponse.error.message
              );
            }
          } catch (err) {
            console.error("Error inserting Maj data:", err);
            toast.error("Error inserting Maj data: " + err.message);
          }
        }
      } else {
        console.error("Error occurred:", response.error?.message);
        toast.error(
          "Unexpected error: " + (response.error?.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Failed to insert property data:", error);
      toast.error("Error updating property data: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <LinkToRegistration />
      {/* <div className="flex min-h-screen"> */}
      <div className="flex flex-grow">
        <div className="w-1/5 bg-white py-4 flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 border-none bg-neutral-400"></div>
        <div className="w-4/5 flex justify-center">
          <div className="w-full   py-6 bg-white rounded-lg">
            <div className="space-y-5">
              {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                  <div className="absolute inset-0 bg-gray-500 opacity-50 backdrop-blur-sm"></div>

                  <TypewriterAnimation />
                </div>
              )}
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                  District:
                </label>
                <div className="block w-full relative sm:col-span-4 grid-cols-1">
                  <select
                    name="dcode"
                    value={formInputData.dcode || ""}
                    onChange={handleInputChange}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  >
                    {/* <option value="">District</option> */}
                    {districtOptions.map((option) => (
                      <option
                        // key={option.districtCode}
                        key={`district-${option.districtCode}`}
                        value={option.districtCode}
                        className="text-xs"
                      >
                        {option.districtName}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                  SRO:
                </label>
                <div className="block w-full relative sm:col-span-4 grid-cols-1">
                  <select
                    name="srocode"
                    value={formInputData.srocode || ""}
                    onChange={handleInputChange}
                    required
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  >
                    {/* <option value="">SRO</option> */}
                    {sroOptions.map((option) => (
                      <option
                        // key={option.sroCode}
                        key={`sro-primary-${option.sroCode}`}
                        value={option.sroCode}
                      >
                        {option.sroName}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>
              {showModalState && <OriginalDeedModal />}
              <div className="grid gap-4 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                  Select Article/Deed Type:
                </label>
                <div className="block w-full relative sm:col-span-4 grid-cols-1">
                  <select
                    name="deedcode"
                    value={formInputData.deedcode || ""}
                    onChange={handleInputChange}
                    required
                    disabled={
                      propertyMod &&
                      (rfeeStatus === "SUCCESS" || StampStatus === "SUCCESS")
                    }
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  >
                    {/* <option value="">Select Deed</option> */}
                    {deedOptions.map((option) => (
                      <option key={option.deedCode} value={option.deedCode}>
                        {option.deedName}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                  Select Sub Article/Sub-Deed Type:
                </label>
                <div className="block w-full relative sm:col-span-4 grid-cols-1">
                  <select
                    name="subDeedCode"
                    value={formInputData.subDeedCode || ""}
                    onChange={handleInputChange}
                    required
                    disabled={
                      propertyMod &&
                      (rfeeStatus === "SUCCESS" || StampStatus === "SUCCESS")
                    }
                    className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  >
                    {/* <option value="">Select Sub Deed</option> */}
                    {subDeedOptions.map((option) => (
                      <option
                        key={option.subDeedCode}
                        value={option.subDeedCode}
                      >
                        {option.subDeedName}
                      </option>
                    ))}
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>

              <div className="flex justify-between items-center"></div>
              <hr className=" h-0.5 border-none bg-neutral-400" />

              {bookNoOptions === "1" ? (
                <>
                  <div className="flex justify-start items-center sm:space-x-36 space-x-24 px-8 text-sm">
                    <h6 className="text-sm font-semibold">Select rate list</h6>
                    <div className="flex space-x-4 ">
                      <label className="flex items-center text-sm">
                        <input
                          type="radio"
                          name="rateList"
                          value="From 16 Feb 2023"
                          // checked={rateyear === "From 16 Feb 2023"}
                          checked={norm(rateyear) === norm("From 16 Feb 2023")}
                          onChange={handleRatetListRadio}
                        />
                        <span className="ml-2">From 16 Feb 2023</span>
                      </label>
                      <label className="flex items-center text-sm">
                        <input
                          type="radio"
                          name="rateList"
                          value="From 5 Oct 2025"
                          checked={norm(rateyear) === norm("From 5 Oct 2025")}
                          onChange={handleRatetListRadio}
                        />
                        <span className="ml-2">From 5 Oct 2025</span>
                      </label>
                    </div>
                  </div>

                  <hr className=" h-0.5 border-none bg-neutral-400" />

                  {formInputData.deedcode === "10" ? (
                    <>
                      <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          Primary Property Location:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="locationCircleRate"
                            value={formInputData?.locationCircleRate}
                            onChange={handleSelectChange}
                            required
                            disabled={
                              propertyMod &&
                              (rfeeStatus === "SUCCESS" ||
                                StampStatus === "SUCCESS")
                            }
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {landRateCalculationOptions.map((option) => (
                              <option
                                key={option.segmentcode}
                                value={option.segmentcode}
                              >
                                {option.segmentdesc}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                          Circle Rate:
                        </label>
                        <p className="text-red-600 sm:col-span-1 grid-cols-1">
                          {formInputData.circle_rate}
                        </p>

                        <RateListModal
                          show={showRatelist}
                          handleClose={handleCloseModal}
                          data={rateListDetails}
                          onSelect={handleSelectRate}
                        />
                      </div>

                      <label className="block w-full px-5 py-5 m-2 text-sm font-semibold">
                        Secondary Property Details:
                      </label>
                      <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          District:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="secDcode"
                            value={formInputData.secDcode || ""}
                            onChange={handleInputChange}
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {districtOptions.map((option) => (
                              <option
                                key={option.districtCode}
                                value={option.districtCode}
                              >
                                {option.districtName}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          SRO:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="secSrocode"
                            value={formInputData.secSrocode || ""}
                            onChange={handleInputChange}
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {sroOptions.map((option) => (
                              <option
                                // key={option.sroCode}
                                key={`sro-secondary-${option.sroCode}`}
                                value={option.sroCode}
                              >
                                {option.sroName}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"></label>
                        <div className="block w-full relative sm:col-span-1 grid-cols-1"></div>
                      </div>

                      <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          Secondary Property Location:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="villageMauza"
                            value={formInputData.villageMauza || ""}
                            onChange={handleMauzaChange}
                            disabled={
                              propertyMod &&
                              (rfeeStatus === "SUCCESS" ||
                                StampStatus === "SUCCESS")
                            }
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {landRateCalculationOptions.map((option) => (
                              <option
                                key={option.segmentcode}
                                value={option.segmentcode}
                              >
                                {option.segmentdesc}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          Land Rate Calculation:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="locationCircleRate"
                            value={formInputData.locationCircleRate}
                            onChange={handleSelectChange}
                            required
                            disabled={
                              propertyMod &&
                              (rfeeStatus === "SUCCESS" ||
                                StampStatus === "SUCCESS")
                            }
                            className="block w-full max-w-md overflow-hidden text-ellipsis pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {landRateCalculationOptions.map((option) => (
                              <option
                                key={option.segmentcode}
                                value={option.segmentcode}
                              >
                                {option.segmentdesc}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                          Circle Rate:
                        </label>
                        <p className="text-red-600 sm:col-span-1 grid-cols-1">
                          {formInputData.circle_rate}
                        </p>

                        <RateListModal
                          show={showRatelist}
                          handleClose={handleCloseModal}
                          data={rateListDetails}
                          onSelect={handleSelectRate}
                        />
                      </div>

                      <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          Village/ Mauza for Index:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="villageMauza"
                            value={formInputData.villageMauza || ""}
                            onChange={handleMauzaChange}
                            className="block w-full max-w-md overflow-hidden text-ellipsis pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {landRateCalculationOptions.map((option) => (
                              <option
                                key={option.segmentcode}
                                value={option.segmentcode}
                              >
                                {option.segmentdesc}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          Select Mutation Details:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="mutationDepartment"
                            value={formInputData.mutationDepartment || ""}
                            onChange={handleInputChange}
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {mutationOptions.map((option) => (
                              <option
                                key={option.office_type_code}
                                value={option.office_type_code}
                              >
                                {option.office_Type_Name}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                      </div>

                      <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                          Select Office Details:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <select
                            name="mutationOfficeCode"
                            value={formInputData.mutationOfficeCode || ""}
                            onChange={handleInputChange}
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            {mutationOfficeOptions.map((option) => (
                              <option
                                key={option.urban_code}
                                value={option.urban_code}
                              >
                                {option.urban_Name}
                              </option>
                            ))}
                          </select>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                        <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1"></label>
                      </div>
                    </>
                  )}

                  <div className="flex justify-between items-center"></div>
                  <hr className=" h-0.5 border-none bg-neutral-400" />

                  <div className="flex justify-start items-center sm:space-x-24 space-x-10 px-8 text-sm">
                    <h6 className="text-sm font-semibold">Select Rebate:</h6>
                    <div className="flex flex-row space-x-4 text-sm">
                      <label className="flex items-center">
                        <input
                          name="disableFlag"
                          type="checkbox"
                          checked={formInputData.disableFlag === "Y"}
                          onChange={handleInputChange}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                        />
                        <span className="ml-2">Disable Person</span>
                      </label>
                      <label className="flex items-center">
                        <input
                          name="femaleBuyer"
                          type="checkbox"
                          checked={formInputData.femaleBuyer === "Y"}
                          onChange={handleInputChange}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                        />
                        <span className="ml-2">Female Buyer</span>
                      </label>
                      <label className="flex items-center">
                        <input
                          name="armyFlag"
                          type="checkbox"
                          checked={formInputData.armyFlag === "Y"}
                          onChange={handleInputChange}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                        />
                        <span className="ml-2">Army Buyer</span>
                      </label>
                      <label className="flex items-center">
                        <input
                          name="coOwnerFlag"
                          type="checkbox"
                          checked={formInputData.coOwnerFlag === "Y"}
                          onChange={handleInputChange}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                        />
                        <span className="ml-2">Co-Owner(Family Member)</span>
                      </label>
                      {formInputData.coOwnerFlag === "Y" && (
                        <div className="flex items-center space-x-2">
                          <label htmlFor="numberSelect">No of Co-Owner:</label>
                          <div className="block w-full relative">
                            <select
                              id="numberSelect"
                              name="coOwnerNo"
                              value={formInputData.coOwnerNo || null}
                              onChange={handleInputChange}
                              disabled={
                                propertyMod &&
                                (rfeeStatus === "SUCCESS" ||
                                  StampStatus === "SUCCESS")
                              }
                              className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                            >
                              {numbers.map((number) => (
                                <option key={number} value={number}>
                                  {number}
                                </option>
                              ))}
                            </select>
                            <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <hr className=" h-0.5 border-none bg-neutral-400" />

                  <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                      Khewat No.:
                    </label>
                    <div className="block w-full relative sm:col-span-3 grid-cols-1">
                      <input
                        type="text"
                        id="khewat"
                        name="khewat"
                        value={formInputData.khewat || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                      House/ Flat No.:
                    </label>
                    <div className="block w-full relative sm:col-span-3 grid-cols-1">
                      <input
                        type="text"
                        id="houseNo"
                        name="houseNo"
                        value={formInputData.houseNo || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-2">
                      Area / Unit:
                    </label>
                    <div className="block w-full relative sm:col-span-3 col-span-1">
                      <div className="flex w-full">
                        <input
                          type="text"
                          name="area"
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/\D/g, ""); // Allow only numbers
                          // }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/[^0-9.]/g, "") // strip non-digits/non-dots
                              .replace(/(\..*?)\..*/g, "$1"); // keep only first dot
                          }}
                          value={formInputData.area || ""}
                          required
                          onChange={handleInputChange}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                          className="block w-1/2 pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm "
                        />
                        <select
                          name="unit"
                          value={formInputData.unit || ""}
                          onChange={handleInputChange}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                          className="block w-1/2 pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-200 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          required
                        >
                          {unitOptions.map((option) => (
                            <option
                              key={option.unitcode}
                              value={option.unitcode}
                            >
                              {option.unitdesc1}
                            </option>
                          ))}
                        </select>
                      </div>
                      <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>

                  <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                      Khatoni No.:
                    </label>
                    <div className="block w-full relative sm:col-span-3 grid-cols-1">
                      <input
                        name="khatoni"
                        type="text"
                        id="khatoni"
                        value={formInputData.khatoni || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                      Khasra No.:
                    </label>
                    <div className="block w-full relative sm:col-span-3 grid-cols-1">
                      <input
                        name="khasra"
                        type="text"
                        id="khasra"
                        value={formInputData.khasra || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                      Select Floor:
                    </label>
                    <div className="block w-full relative sm:col-span-3 grid-cols-1">
                      <select
                        name="floorno"
                        value={formInputData.floorno || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      >
                        <option disabled value="">
                          select
                        </option>
                        {floorMasOptions.map((option) => (
                          <option
                            key={option.floor_code}
                            value={option.floor_code}
                          >
                            {option.floor_name}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    {formInputData.deedcode === "01" ||
                    formInputData.deedcode === "03" ||
                    formInputData.deedcode === "25" ? (
                      <>
                        {/* GIS No. */}
                        <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                          GIS No.:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <div className="relative">
                            <input
                              name="gisNo"
                              type="text"
                              id="gisNo"
                              value={formInputData.gisNo || ""}
                              onChange={handleInputChange}
                              className="block w-full pl-2 pr-10 py-1.5 border-none shadow-sm bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                              placeholder="Enter GIS No"
                            />
                            <button
                              type="button"
                              onClick={handleGisSearch}
                              disabled={isGisLoading}
                              className="absolute right-2 top-1/2 -translate-y-1/2 hover:opacity-80"
                              title="Search GIS"
                            >
                              {isGisLoading ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5 animate-spin"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    strokeWidth="2"
                                    opacity="0.25"
                                  />
                                  <path d="M4 12a8 8 0 018-8" strokeWidth="2" />
                                </svg>
                              ) : (
                                // magnifying glass icon
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <circle cx="11" cy="11" r="8"></circle>
                                  <line
                                    x1="21"
                                    y1="21"
                                    x2="16.65"
                                    y2="16.65"
                                  ></line>
                                </svg>
                              )}
                            </button>
                          </div>
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>

                        {/* Latitude */}
                        <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                          Property Latitude:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <input
                            name="latitude"
                            type="text"
                            id="latitude"
                            value={formInputData.latitude || ""}
                            onChange={handleInputChange}
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-200 text-gray-600  text-sm"
                          />
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>

                        {/* Longitude */}
                        <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                          Property Longitude:
                        </label>
                        <div className="block w-full relative sm:col-span-3 grid-cols-1">
                          <input
                            name="longitude"
                            type="text"
                            id="longitude"
                            value={formInputData.longitude || ""}
                            onChange={handleInputChange}
                            className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-200 text-gray-600 text-sm"
                          />
                          <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                        </div>
                      </>
                    ) : null}
                  </div>

                  <div className="grid gap-2 m-8 sm:grid-cols-12 grid-cols-2 items-center text-sm">
                    <label className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1">
                      Rider:
                    </label>
                    <div className="block w-full relative sm:col-span-3 grid-cols-1">
                      <select
                        name="riderCode"
                        value={formInputData.riderCode || ""}
                        onChange={handleInputChange}
                        disabled={
                          propertyMod &&
                          (rfeeStatus === "SUCCESS" ||
                            StampStatus === "SUCCESS")
                        }
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      >
                        <option disabled value="">
                          select
                        </option>
                        {riderOptions.map((option) => (
                          <option
                            key={option.percenT_RATE}
                            value={option.percenT_RATE}
                          >
                            {option.rideR_DESC}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>

                  {/* GIS API response table in single row */}
                  {gisLookup && (
                    <div className="m-8">
                      <h6 className="text-sm font-semibold mb-2">
                        GIS Details:
                      </h6>
                      <table className="table-auto border border-gray-300 w-full text-sm">
                        <thead>
                          <tr>
                            <th className="border px-2 py-1">GIS ID</th>
                            <th className="border px-2 py-1">Latitude</th>
                            <th className="border px-2 py-1">Longitude</th>
                            <th className="border px-2 py-1">Property Type</th>
                            <th className="border px-2 py-1">Circle Rate</th>
                            <th className="border px-2 py-1">Attachment</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="border px-2 py-1">
                              {gisLookup.GIS_ID}
                            </td>
                            <td className="border px-2 py-1">
                              {gisLookup.Latitude}
                            </td>
                            <td className="border px-2 py-1">
                              {gisLookup.Longitude}
                            </td>
                            <td className="border px-2 py-1">
                              {gisLookup.Property_Type}
                            </td>
                            <td className="border px-2 py-1">
                              {gisLookup.Circle_Rate}
                            </td>
                            <td className="border px-2 py-1">
                              <a
                                href={gisLookup.Attachment}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                View
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="grid gap-2 m-8 sm:grid-cols-2 grid-cols-2 items-center text-sm sm:w-1/2">
                    <button
                      className="block w-full relative col-span-1 bg-blue-500 text-white rounded-full sm:p-2 p-0"
                      onClick={openResidentialModal}
                    >
                      Residential/Agricultural Construction
                    </button>
                    <button
                      className="block w-full relative col-span-1 bg-blue-500 text-white rounded-full sm:p-2 p-0"
                      onClick={openCommercialModal}
                    >
                      Commercial/Industrial Construction
                    </button>

                    {showResidentialModalState && (
                      <ResidentialModal
                        onClose={closeResidentialModal}
                        dcode={formInputData.dcode}
                        srocode={formInputData.srocode}
                      />
                    )}
                    {showCommercialModalState && (
                      <CommercialModal
                        onClose={closeCommercialModal}
                        dcode={formInputData.dcode}
                        srocode={formInputData.srocode}
                      />
                    )}
                  </div>

                  <div className="grid gap-2 m-8 sm:grid-cols-10 grid-cols-1 items-center text-sm">
                    <label className="block w-full relative text-sm font-semibold sm:col-span-2 grid-cols-1">
                      Property Boundaries:
                    </label>
                    <div className="block w-full relative sm:col-span-2 grid-cols-1">
                      <input
                        name="east"
                        type="text"
                        placeholder="East"
                        value={formInputData.east || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <div className="block w-full relative sm:col-span-2 grid-cols-1">
                      <input
                        name="west"
                        type="text"
                        placeholder="West"
                        value={formInputData.west || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <div className="block w-full relative sm:col-span-2 grid-cols-1">
                      <input
                        name="north"
                        type="text"
                        placeholder="North"
                        value={formInputData.north || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                    <div className="block w-full relative sm:col-span-2 grid-cols-1">
                      <input
                        name="south"
                        type="text"
                        placeholder="South"
                        value={formInputData.south || ""}
                        onChange={handleInputChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                </>
              ) : null}

              <div className="flex justify-center mt-5">
                <button
                  type="button"
                  className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                  onClick={propertyMod ? handleUpdate : handleSave}
                >
                  {propertyMod ? "Update" : "Save & Continue"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Property;
